import { FunctionComponent, PropsWithChildren, useEffect, useRef, useState } from 'react'

type LazyVisibleProps = PropsWithChildren<{
  minHeight: number | string
  rootMargin?: string
}>

export const LazyVisible: FunctionComponent<LazyVisibleProps> = ({ minHeight, rootMargin = '50px', children }) => {
  const [isVisible, setIsVisible] = useState(typeof IntersectionObserver === 'undefined')
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    if (!element || typeof IntersectionObserver === 'undefined') return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin }
    )

    observer.observe(element)
    return () => observer.disconnect()
  }, [rootMargin])

  return <div ref={ref}>{isVisible ? children : <div style={{ minHeight }} />}</div>
}
